import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  min-height: ${primitives.size['size-1600']};
  padding: ${space['space-200']} ${space['space-200']} ${space['space-200']} ${space['space-600']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('input', 'radius-md')};
  background: ${semantic.bg.canvas};
  box-sizing: border-box;
  transition: border-color 120ms ease;

  &:focus-within {
    border-color: ${semantic.border.selected};
  }

  &[data-error='true'] {
    border-color: ${semantic.border.danger};
  }

  &[data-disabled='true'] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FieldStack = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${space['space-050']};
`;

export const InlineLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.secondary};
`;

export const Input = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};
  padding: 0;
  width: 100%;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ApplyButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${primitives.size['size-1200']};
  padding: 0 ${space['space-600']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.tertiary};
  background: ${semantic.bg.surfaceSubtle};
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  cursor: pointer;
  white-space: nowrap;
  transition: color 120ms ease, background 120ms ease;

  &[data-active='true'] {
    color: ${semantic.text.inverse};
    background: ${semantic.bg.brand};
  }

  &[data-active='true']:hover {
    opacity: 0.85;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.danger};
`;

export const AppliedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;

export const SuccessRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-200']};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};
`;

export const SuccessCheck = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${primitives.size['size-400']};
  height: ${primitives.size['size-400']};
  color: ${semantic.text.positive};
`;

export const AppliedCard = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  padding: ${space['space-300']} ${space['space-400']};
  border-radius: ${radius('card', 'radius-sm')};
  background: ${semantic.bg.surfaceSubtle};
  box-sizing: border-box;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const AppliedBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const AppliedCode = styled.span`
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AppliedAmount = styled.span`
  flex-shrink: 0;
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.positive};
`;

export const AppliedDescription = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.secondary};
`;

export const RemoveIconButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${primitives.size['size-500']};
  height: ${primitives.size['size-500']};
  padding: 0;
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  background: transparent;
  color: ${semantic.text.secondary};
  cursor: pointer;
  transition: color 120ms ease;

  &:hover {
    color: ${semantic.text.primary};
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
